import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

// Stop the timer as close to 5.000s as you can — WITHOUT seeing the clock.
export function TimeGuesser({ onScore }) {
  const [phase, setPhase] = useState("idle"); // idle | running | done
  const [elapsed, setElapsed] = useState(0);
  const [diff, setDiff] = useState(null);
  const startT = useRef(0);
  const reported = useRef(false);
  const TARGET = 5;

  const start = () => { startT.current = performance.now(); setPhase("running"); setDiff(null); reported.current = false; };

  const stop = () => {
    const e = (performance.now() - startT.current) / 1000;
    setElapsed(e);
    const d = Math.abs(e - TARGET);
    setDiff(d);
    setPhase("done");
  };

  useEffect(() => { if (phase === "done" && !reported.current) { reported.current = true; onScore?.(Math.max(50, Math.round((1 - Math.min(diff, 1)) * 1000))); } }, [phase, diff, onScore]);

  return (
    <div className="flex flex-col items-center text-center" data-testid="time-guesser">
      <p className="font-display font-black text-2xl uppercase mb-2">Stop at exactly <span className="text-neon-cyan">5.000s</span></p>
      <p className="text-zinc-400 mb-6 max-w-xs">No clock to help you — trust your internal timer!</p>

      {phase === "idle" && (
        <Button onClick={start} data-testid="time-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase h-14 px-10 text-lg">
          <Play className="w-5 h-5 mr-2 fill-black" /> Start Timer
        </Button>
      )}
      {phase === "running" && (
        <button onClick={stop} data-testid="time-stop" className="w-56 h-56 rounded-full bg-neon-pink text-black font-display font-black text-2xl uppercase active:scale-95 transition-transform" style={{ boxShadow: "0 0 40px #FF003C" }}>
          STOP
        </button>
      )}
      {phase === "done" && (
        <>
          <p className="font-display font-black text-5xl text-neon-yellow mb-1" data-testid="time-result">{elapsed.toFixed(3)}s</p>
          <p className={`font-display font-bold text-lg mb-4 ${diff < 0.1 ? "text-neon-lime" : diff < 0.5 ? "text-neon-cyan" : "text-neon-pink"}`}>
            {diff < 0.1 ? "Incredible! 🎯" : diff < 0.3 ? "So close!" : diff < 0.6 ? "Not bad!" : "Way off!"} (off by {diff.toFixed(3)}s)
          </p>
          <Button onClick={start} className="bg-neon-cyan text-black rounded-none font-bold uppercase">Try Again</Button>
        </>
      )}
    </div>
  );
}
